import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import { routes } from './router.js'
import { initAnalytics, trackPageview } from './utils/analytics.js'
import './style.css'

// The router must be INSTALLED (app.use) — RouterView/RouterLink/useRoute
// all resolve through the injections the install provides. Creating the
// router without installing it renders an empty shell.
const router = createRouter({ history: createWebHistory(), routes })

initAnalytics().catch(() => {
  // Analytics must never block app boot.
})

router.afterEach((to) => {
  initAnalytics()
    .then(() => trackPageview(to.fullPath))
    .catch(() => {
      // Ignore blocked scripts and network failures.
    })
})

async function boot() {
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === '1') {
    const { startMockWorker } = await import('./mocks/browser.js')
    await startMockWorker()
  }

  const app = createApp(App).use(router)
  await router.isReady()
  app.mount('#app')
}

boot()
